import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AdvisingAntifraudService {
    constructor(private http: HttpClient) {}
    getConfigValidatorList(): Observable<any> {
        return this.http.get(environment.api_url + `/config/validator/advising_antifraud/list`);
    }
    updateConfigValidator(validator): Observable<any> {
        return this.http.post(
            environment.api_url + `/config/validator/advising_antifraud/${validator.id}/edit`,
            validator
        );
    }
}
